/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".exclamationmark[_ngcontent-%COMP%], .warning-title[_ngcontent-%COMP%]{color:#036}"];
export { styles as styles };
